import './Footer.css';
import { FC } from 'react';

const Footer: FC = () => {
  return (
    <footer className="footer"></footer>
  );
}

export default Footer;
